import { Component, Input } from '@angular/core';
import { GridComponent } from "../../grid/grid.component";
import { ShowModel } from "../planification.component";
import { MatDialog } from "@angular/material/dialog";
import { SlotWithSequence } from "../../../../../_models/planification/SlotWithSequence";
import { LocalStorageKey } from "../../../../../_models/constants/local-storage";
import { traductionsKeysEnum } from 'src/assets/i18n/traductionsKeysEnum';

@Component({
    selector: 'app-on-show-slot',
    templateUrl: './on-show-slot.component.html',
    styleUrls: ['./on-show-slot.component.scss']
})
export class OnShowSlotComponent {

    @Input() slot: SlotWithSequence;
    @Input() isOpen: boolean;
    @Input() listMarketing: any[];
    @Input() marketingId: number;
    @Input() showModel: ShowModel;

    constructor(
        private dialog: MatDialog,
    ) {
    }

    modeDaltonien(usedRate: any) {
        if (localStorage.getItem(LocalStorageKey.modeDaltonien) === 'false') {
            return 'card-cell';
        } else {
            if (usedRate === 0) {
                return 'card-cell-0';
            } else if (usedRate === 1) {
                return 'card-cell-2';
            } else {
                return 'card-cell-1';
            }
        }
    }

    getColor(usedRate: number) {
        if (usedRate === 0) {
            return '#00FF7F';
        } else if (usedRate === 1) {
            return '#708090';
        } else {
            return '#f69d3c';
        }
    }

    openDialog(slot: SlotWithSequence) {
        this.isOpen = false;
        const data: any = {
            slot,
            message: 'More Actions',
            buttonText: {
                close: 'Fermer'
            }
        }

        if (this.listMarketing.find(value => value.cibleMarketingId === this.marketingId)) {
            data.label = this.listMarketing.find(value => value.cibleMarketingId === this.marketingId).label;
        }

        const dialogRef = this.dialog.open(GridComponent, {
            data
        });
        dialogRef.afterClosed().subscribe(_ => {
            this.isOpen = true;
        });
    }

    showMode(slot: SlotWithSequence) {
        const array = [];
        if (this.showModel.showPrice) {
            array.push(slot.price + '€');
        }
        if (this.showModel.showDuration) {
            array.push(slot.duration + 's');
        }
        if (this.showModel.showFreeSpace) {
            array.push(slot.freeSpace + 's');
        }
        if (this.showModel.showGrp) {
            array.push(slot.audienceForTarget ? slot.audienceForTarget.grecGrp.toFixed(2) : 'non précisé');
        }
        if (this.showModel.showCGRPBrut) {
            array.push(slot.indexedCgrp ? slot.indexedCgrp.toFixed(2) : 'non précisé');
        }
        if (this.showModel.showSpotCount) {
            array.push(slot.spotMaxNumber ?? '? spots');
        }
        if (this.showModel.showSpotCountFree) {
            array.push(slot.freeSpace ?? '? spots libres');
        }
        if (this.showModel.showSpotCountHalfFree) {
            if ('semiFreeSpace' in slot) {
                array.push(slot.semiFreeSpace ?? '? spots semi libres');
            }
        }

        return array.map((c, _) => `${c}`).join(' - ');
    }

    verify(value: any): boolean {
        return value && value !== '';
    }

      protected readonly traductionsKeysEnum = traductionsKeysEnum;
}
